export const SEND_DOCUMENTS_TO_ASSOCIATE = "SEND_DOCUMENTS_TO_ASSOCIATE";
